import { render, staticRenderFns } from "./women.vue?vue&type=template&id=195cbac0&scoped=true&"
import script from "./women.vue?vue&type=script&lang=js&"
export * from "./women.vue?vue&type=script&lang=js&"
import style0 from "./women.vue?vue&type=style&index=0&id=195cbac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195cbac0",
  null
  
)

export default component.exports